export const TEST_DRIVE_DIALOG_ID = 'TEST_DRIVE_DIALOG';
